import React, { useEffect, useState } from "react"

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ApplicationState } from "../../store/index"
import { Avatar, Box, Divider, Grid, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { formatData, formatMoney, isEmpty } from "../../services/utils";
import { LogoMarca } from "../../components/logo";
import { AtendimentoViewProps, listPeriodo, mapDispatchToAtendimentoProps, mapStateToAtendimentoProps } from "../atendimento/atendimento.controller";
import { format } from "@react-input/mask";

const useStyles = makeStyles()((theme: Theme) => ({
    containerText: {
        display: 'flex',
        flex: 1,
    },
    text: {
        maxWidth: '60mm',
        color: '#000',
        whiteSpace: 'nowrap',
        textOverflow: 'clip'
    },
    title: {
        color: '#000',
        font: 'caption 12pt',
        fontWeight: 'bold',

    },
    textDescricao: {
        maxWidth: '60mm',
        color: '#000',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    headerItens: {
        borderBottom: '1px dashed #000',
    },
    footerItens: {
        borderTop: '1px dashed #000',
    }

}));

///center left
interface PrintLineProps {
    text: any,
    bolder?: boolean
    align?: "start" | "center" | "left"
    title?: boolean
}
function PrintLine({ text, bolder, align, title }: PrintLineProps) {
    const { classes } = useStyles()
    var justifyContent = 'start'
    if (align)
        justifyContent = align
    if (title) {
        return (
            <div style={{ display: 'flex', flex: 1, justifyContent: justifyContent, font: 'status-bar', margin: 5, whiteSpace: 'nowrap' }}>
                <span className={classes.title}>{text}</span>
            </div>
        )
    }
    return (
        <div style={{ display: 'flex', flex: 1, justifyContent: justifyContent, overflow: "clip" }}>
            {bolder ? (
                <span className={classes.text}><b>{text}</b></span>
            ) : (
                <span className={classes.text}>{text}</span>
            )}

        </div>
    )
}




function PrintHeaderEmpresa() {

    return (
        <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                <LogoMarca />
            </div>
            <div style={{ display: "flex", flex: 3, flexDirection: "column" }}>
                <PrintLine text={""} align="start" />
            </div>
            <div style={{ display: "flex", flex: 1 }}>
                <PrintLine text={formatData(new Date().toISOString())} align="left" />
            </div>
        </div>
    )
}


const PrintHeaderEmpConnetedData = PrintHeaderEmpresa


function ContainerPageA4({ children }: any) {
    return (
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', font: '10pt courier', '@page': { size: 'A4' }, padding: 2 }} >
            {children}
        </Box>
    )
}

const LinhaDivisao = () => {
    return (
        <div style={{ display: "flex", flex: 1, borderBottom: '1px solid #000', }}></div>
    )
}

const LinhaDivisaoLigth = () => {
    return (
        <div style={{ display: "flex", flex: 1, borderBottom: '1px solid #888', }}></div>
    )
}

export const PrintAtendimentoList = connect(mapStateToAtendimentoProps, mapDispatchToAtendimentoProps)((props: AtendimentoViewProps) => {
    const { rowTratamentoGroup, filtro } = props.atendimentoState


    const orderBy = () => {
        try {
            if (rowTratamentoGroup.rows.length > 0) {
                let rows = rowTratamentoGroup.rows.slice();
                return rows.sort((a, b) => {
                    let nomeA = a.paciente.nome.trimStart();
                    let nomeB = b.paciente.nome.trimStart();
                        if (nomeA > nomeB) {
                            return 1
                        } else if (nomeB > nomeA) {
                            return -1 
                        } else return 0
                })
            }
            return rowTratamentoGroup.rows
        } catch (error) {
            console.log(error)
            return rowTratamentoGroup.rows
        }
    }

    if (rowTratamentoGroup.descricao)
        return (
            <ContainerPageA4>
                <PrintHeaderEmpConnetedData />
                <br />
                <PrintLine text={`Pacientes para tratamento de ${rowTratamentoGroup.descricao}`} align="center" title={true} />
                <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
                    <PrintLine text={`Situação: ${filtro.situacao}`} align="center" title={true} />
                    {filtro.status !== "todos" && (
                        <PrintLine text={`Status: ${filtro.status}`} align="center" title={true} />
                    )}
                </div>


                <LinhaDivisao />

                {/* itens */}
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column', font: 'caption' }}>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                        <div style={{ width: '35%' }} >{<PrintLine text="Paciente" bolder={true} />}</div>
                        <div style={{ width: '20%' }} >{<PrintLine text="WhatsApp" bolder={true} align="left" />} </div>
                        <div style={{ width: '15%' }}  >{<PrintLine text="Periodo Ret." bolder={true} />}    </div>
                        <div style={{ width: '15%' }} >{<PrintLine text="Realizado" bolder={true} />}</div>
                        <div style={{ width: '15%' }} >{<PrintLine text="Retorno" bolder={true} />}</div>
                    </div>
                    <LinhaDivisao />
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                        {orderBy().map((row, idx) => {
                            let idxPeriodo = listPeriodo.findIndex(vl => vl.qtdias == Number(row.tratamento.periodo_retorno));
                            if (idxPeriodo === -1)
                                idxPeriodo = 0;
                            return (
                                <div key={idx} style={{ display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', }}>
                                        <div style={{ width: '38%' }}><PrintLine text={String(row.paciente.nome).substring(0, 60)} bolder={false} /></div>
                                        <div style={{ width: '19%' }}><PrintLine text={format(row.paciente.whatsapp, { mask: "(__)_ ____-____", replacement: { _: /\d/ } })} bolder={false} align="left" /> </div>
                                        <div style={{ width: '13%' }}><PrintLine text={listPeriodo[idxPeriodo].periodo} bolder={false} /> </div>
                                        <div style={{ width: '15%' }}><PrintLine text={formatData(row.tratamento.data_tratamento)} bolder={false} /> </div>
                                        <div style={{ width: '15%' }}><PrintLine text={formatData(row.tratamento.data_retorno)} bolder={false} /> </div>
                                    </div>
                                    <div style={{ width: '100%', fontStyle: "italic" }}><PrintLine text={row.obs} bolder={false} /> </div>
                                    <LinhaDivisaoLigth />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </ContainerPageA4>
        )
    return <div></div>
})


